import { ChangeDetectionStrategy, Component, ContentChildren, QueryList } from '@angular/core';

import { PeriodService } from '../../services/index';
import { ProgramComponent } from '../program/program.component';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleComponent {
  @ContentChildren(ProgramComponent)
  programs: QueryList<ProgramComponent>;

  constructor(private periodService: PeriodService) {}

  editSchedule(): void {
    const dayId = this.programs.first.scheduleId;
    this.periodService.multipleDaysSelection$.next([dayId]);
  }
}
